/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Integration_Not_ConfiguredInputs */

const cs_error_integration_not_configured = /** @type {(inputs: Error_Integration_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tato integrace není pro workspace nastavená. Požádejte správce.`)
};

const en_error_integration_not_configured = /** @type {(inputs: Error_Integration_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This integration is not configured for this workspace. Ask an administrator.`)
};

/**
* | output |
* | --- |
* | "This integration is not configured for this workspace. Ask an administrator." |
*
* @param {Error_Integration_Not_ConfiguredInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const error_integration_not_configured = /** @type {((inputs?: Error_Integration_Not_ConfiguredInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Integration_Not_ConfiguredInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_error_integration_not_configured(inputs)
	return cs_error_integration_not_configured(inputs)
});